import { sanitize } from "dompurify";
import * as React from "react";
import { connect } from "react-redux";
import { IdErrorCore } from "../../constants/IdErrorCore";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { StatusCode } from "../../utils/network/generated/protoTypes";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionErrorResolveError } from "./actionError";
import { ButtonDialog } from "./ButtonDialog";
var _ErrorDialog = function (_a) {
    var message = _a.message, statusCode = _a.statusCode, onOkButton = _a.onOkButton;
    if (message == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var html = {
        __html: sanitize("ErrorCode: " + statusCode + "<br/>ErrorMessage: " + message),
    };
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.alert_anErrorOccurred_title, className: "" + IdStyles.ModalBackgroundInfo },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement("div", { className: "flex flex--guts flex--stacked flex__full" },
                React.createElement("hr", { className: "dialog-divider" }),
                React.createElement("span", { className: "flex flex--guts " + IdStyles.TextAlignCenter + " " + IdStyles.TextNormal },
                    React.createElement("span", { className: IdStyles.TextBoldPrimary, dangerouslySetInnerHTML: html })),
                React.createElement("hr", { className: "dialog-divider" })),
            React.createElement(ButtonDialog, { onClick: onOkButton }))));
};
var mapState = function (state) {
    var statusCode = state.errors.UnhandledErrors.length > 0
        ? state.errors.UnhandledErrors[state.errors.UnhandledErrors.length - 1]
        : StatusCode.Undefined;
    var message = statusCode !== StatusCode.Undefined ? StatusCode[statusCode] : undefined;
    return {
        message: message,
        statusCode: statusCode,
    };
};
var mapDispatch = function (dispatch) { return ({
    onOkButton: function () { return dispatch(actionErrorResolveError(IdErrorCore.UnhandledErrors)); },
}); };
export var DialogErrorDOM = connect(mapState, mapDispatch)(_ErrorDialog);



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/DialogErrorDOM.tsx
// module id = 1124
// module chunks = 3